import EXTERNAL_INFO_TYPE from '../../common/constants/externalInfoType';
import renderWixInfoComponents from './renderWixInfoComponents';
import addItemPropsToMasterInfo from './addItemPropsToMasterInfo';
export default function renderMasterInfoElements(type, query, galleryWrapperProps, shouldUseNewSocialSharePopup, pgItemProps) {
    var internalOrExternal = getInternalOrExternal(type);
    // @ts-ignore
    var masterInfoProps = addItemPropsToMasterInfo(pgItemProps, galleryWrapperProps, shouldUseNewSocialSharePopup, internalOrExternal, new Map(Object.entries(query)));
    return renderWixInfoComponents(masterInfoProps);
}
function getInternalOrExternal(type) {
    var HOVER = EXTERNAL_INFO_TYPE.HOVER, EXTERNAL = EXTERNAL_INFO_TYPE.EXTERNAL, SLIDESHOW = EXTERNAL_INFO_TYPE.SLIDESHOW;
    if (type === EXTERNAL || type === SLIDESHOW) {
        return 'external';
    }
    if (type === HOVER) {
        return 'internal';
    }
    throw new Error("MasterInfoElement does not support the externalInfoType: " + type);
}
//# sourceMappingURL=renderMasterInfoElements.js.map